import { render, staticRenderFns } from "./SubfamiliasSelector.vue?vue&type=template&id=037047aa"
import script from "./SubfamiliasSelector.vue?vue&type=script&lang=js"
export * from "./SubfamiliasSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports